import React from 'react'
import ReportWrapper from '../ReportWrapper'
import ReportSectionHeading from '../ReportSectionHeading'
import { Stack, Text } from '@mantine/core'
import { useTheme } from '../../../components/ThemeProvider'
import TianyanchaRecordCard from '../TianyanchaRecordCard'

interface LawSuitCase {
  title: string
  court: string
  judgeTime: string
  caseNo: string
  caseType: string
  caseReason: string
  docType: string
}

interface TianyanchaLawSuitProps {
  data: any
  title: string
  sectionIndex?: string
}

const formatCases = (cases: LawSuitCase[] = []) =>
  cases.map((item) => ({
    name: item.title,
    court: item.court,
    date: item.judgeTime,
    caseNo: item.caseNo,
    type: item.caseType,
    reason: item.caseReason,
    docType: item.docType,
  }))

export default function TianyanchaLawSuit({ data, title, sectionIndex }: TianyanchaLawSuitProps) {
  let jsonData: any
  try {
    jsonData = JSON.parse(data.tianyancha_lawSuit ?? '{}')
  } catch (error) {
    jsonData = {}
  }

  const cases = formatCases(jsonData.items)
  const theme = useTheme()

  return (
    <ReportWrapper>
      <ReportSectionHeading title={title} index={sectionIndex} />
      <div className="mt-2">
        <Text size="sm" fw={600} style={{ color: theme.accentTextColor }}>
          法律诉讼记录
        </Text>
        <Stack gap="sm" className="mt-3">
          {cases.length === 0 ? (
            <Text c="dimmed" size="sm" ta="center">
              暂无相关诉讼信息
            </Text>
          ) : (
            cases.map((item, index) => (
              <TianyanchaRecordCard
                key={`${item.caseNo}-${index}`}
                number={index + 1}
                recordType="案件"
                fields={[
                  { label: '案件名称', value: item.name || '—', span: 2 },
                  { label: '案号', value: item.caseNo || '—' },
                  { label: '案件类型', value: item.type || '—' },
                  { label: '案由', value: item.reason || '—' },
                  { label: '审理法院', value: item.court || '—' },
                  { label: '判决日期', value: item.date || '—' },
                ]}
              />
            ))
          )}
        </Stack>
      </div>
    </ReportWrapper>
  )
}
